import React from 'react'
import useRequirements from '../../../hooks/use-requirements'
import { find } from 'lodash'

const RequirementLabel = ({
    courseRequirement = {}
}) => {
    const [ requirements ] = useRequirements()
    const requirement = find(requirements, { id: courseRequirement.id })
    return (
        <React.Fragment>{requirement ? requirement.name : ' '}</React.Fragment>
    )
}

export default RequirementLabel